<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="user-group-add-form-modal-label">
                {{ $root.text('Add user group', null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-if="updated" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated"></div>
                </div>
            </div>
            <div v-else>
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <form
                    v-if="$root.hasPermission('users_user_groups') || $root.hasPermission('users_own_user_groups')"
                    v-on:submit.prevent="onSubmit()"
                >
                    <div class="form-group">
                        <label for="user-group-name" id="user-group-name-label" class="mandatory-label">
                            {{ $root.text('Name', null, true) }} *
                        </label>
                        <input
                            v-model="user_group.name"
                            type="text"
                            id="user-group-name"
                            class="form-control mandatory-field"
                            :readonly="updating"
                            v-on:keyup="$root.unHighlightErrors('user-group-name')"
                            v-on:change="$root.unHighlightErrors('user-group-name')"
                        >
                    </div>
                    <div v-if="is_private" class="form-group">
                        <label for="user-group-shared-0">{{ $root.text('Group type', null, true) }}</label>
                        <div class="form-control" style="height: auto">
                            <div class="mr-4" style="display: inline-block">
                                <div class="custom-control custom-radio">
                                    <input
                                        v-model="user_group.shared"
                                        type="radio"
                                        id="user-group-shared-0"
                                        class="custom-control-input"
                                        :value="0"
                                        :disabled="updating"
                                    >
                                    <label class="custom-control-label" for="user-group-shared-0">
                                        {{ $root.text('Private group', null, true) }}
                                    </label>
                                </div>
                            </div>
                            <div style="display: inline-block">
                                <div class="custom-control custom-radio">
                                    <input
                                        v-model="user_group.shared"
                                        type="radio"
                                        id="user-group-shared-1"
                                        class="custom-control-input"
                                        :value="1"
                                        :disabled="updating"
                                    >
                                    <label class="custom-control-label" for="user-group-shared-1">
                                        {{ $root.text('Shared group', null, true) }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div
            v-if="($root.hasPermission('users_user_groups') || $root.hasPermission('users_own_user_groups')) && !updated"
            class="modal-footer"
        >
            <span v-if="!updating">
                <span>
                    <button type="button" class="btn btn-primary" @click="onSubmit()">
                        <i class="far fa-check mr-1"></i>
                        {{ $root.text(is_private ? 'Create group and add users' : 'Add', null, true) }}
                    </button>
                </span>
            </span>
            <span v-else>
                <button type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">
                        {{ $root.text(is_private ? 'Create group and add users' : 'Add', null, true) }}
                    </span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['is_private'],
        data () {
            return {
                errors: false,
                updating: false,
                updated: false,
                user_group: {}
            }
        },
        mounted () {
            //
        },
        methods: {
            resetForm: function () {
                if (
                    !this.$root.hasPermission('users_user_groups')
                    && !this.$root.hasPermission('users_own_user_groups')
                ) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.errors = false;
                this.updating = false;
                this.updated = false;
                this.user_group = {
                    private: this.is_private || 0,
                    shared: 1
                };
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                setTimeout(function () {
                    $('#user-group-name').focus();
                }, 500);
            },
            onSubmit: function () {
                this.errors = false;
                this.updating = true;
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                /**
                 * Send request to API
                 */
                const data = this.user_group;
                const url = this.$root.$data.app.api_url + '/' + this.$root.$data.app.client_id + '/user-group';
                var vm = this;

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.$data.token }
                })
                .then(response => {
                    vm.updated = 'Success';
                    if (response.data.message) {
                        vm.updated = response.data.message;
                        if (vm.is_private) {
                            vm.$parent.getUserGroups(response.data.user_group_id);
                        } else {
                            vm.$parent.getUserGroups(1, true);
                        }
                    }

                    setTimeout(function () {
                        $('#user-group-add-form-modal').modal('hide');
                    }, 2000);
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // missing/lost API token - close modal and logout user
                            $('#user-group-add-form-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            if (typeof error.response.data.error === 'string') {
                                vm.errors = error.response.data.error;
                            } else if (typeof error.response.data.error === 'object') {
                                vm.errors = '';
                                for (const [key, value] of Object.entries(error.response.data.error)) {
                                    vm.errors += value.join('<br>') + '<br>';
                                    $('#user-group-' + key + '-label').addClass('text-danger');
                                    $('#user-group-' + key).addClass('field-error');
                                }
                            }
                        }
                    }
                })
                .finally(() =>
                    vm.updating = false
                );
            }
        }
    }
</script>
